module.exports = __webpack_public_path__ + "img/lose.6c3c04c6.svg";